import { getUser } from "../../utilis/Common";
import { formatDate } from "../TaskManagement/workspaceConstants";

export { formatDate };

export const CMS_PRIMARY = "#007BFF";

export const JD_PAGE_SHELL = "px-2 pb-8 sm:px-3";

export { MODULE_PAGE_SHELL_STYLE } from "../TaskManagement/workspaceConstants";

export const JD_ACCEPTED_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const JD_ACCEPTED_EXTENSIONS = [".pdf", ".doc", ".docx"];

export const JD_MAX_BYTES = 25 * 1024 * 1024;

export const formatFileSize = (bytes) => {
  if (!bytes) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatJdDate = (value) => {
  if (!value) return "—";
  return new Date(value).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

export const getFileExtension = (name = "") => {
  const parts = name.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
};

export const deriveTitleFromFileName = (name = "") => {
  const base = name.replace(/\.[^.]+$/, "").replace(/[_-]+/g, " ").trim();
  return base || "Job Description";
};

export const getCurrentUserMeta = () => {
  const user = getUser();
  return {
    id: user?.id || 1,
    name: user?.name || "Current User",
    department: user?.department || "General",
    branch_id: user?.main_branch || user?.branch_id || "",
  };
};

export const getBranchAgencyName = (branch) => branch?.agencyname || branch?.name || "";

const now = new Date();
const daysAgo = (n) => {
  const d = new Date(now);
  d.setDate(d.getDate() - n);
  return d.toISOString();
};

export const createSeedMyJd = () => ({
  id: 1,
  job_title: "Senior Admissions Officer",
  department: getCurrentUserMeta().department,
  original_file_name: "Job_Description_Senior_Admissions.pdf",
  file_type: "pdf",
  file_size: 248000,
  effective_date: "2025-01-15",
  notes: "Signed copy from HR onboarding.",
  version_number: 2,
  is_current: true,
  preview_url: null,
  created_at: daysAgo(12),
  updated_at: daysAgo(3),
});

export const createSeedJdHistory = () => [
  {
    id: 2,
    version_number: 1,
    original_file_name: "JD_Senior_Admissions_v1.pdf",
    file_type: "pdf",
    file_size: 231000,
    created_at: daysAgo(180),
  },
];

export const BRANCH_OPTIONS = [
  "All branches",
  "Sydney",
  "Melbourne",
  "Brisbane",
  "Perth",
  "Adelaide",
];

export const BRANCH_FILTER_OPTIONS = BRANCH_OPTIONS.filter((b) => b !== "All branches");

export const JD_STATUS_FILTER_OPTIONS = [
  { value: "uploaded", label: "Uploaded" },
  { value: "missing", label: "Missing" },
];

export const createSeedTeamJds = () => [
  {
    id: 101,
    user_id: 2,
    name: "Sarah Ahmed",
    branch: "Sydney",
    department: "Admissions",
    job_title: "Senior Admissions Officer",
    status: "uploaded",
    original_file_name: "Sarah_Ahmed_JD.pdf",
    file_type: "pdf",
    updated_at: daysAgo(3),
  },
  {
    id: 102,
    user_id: 3,
    name: "James Wilson",
    branch: "Melbourne",
    department: "Operations",
    job_title: "Operations Lead",
    status: "uploaded",
    original_file_name: "James_Wilson_JD.docx",
    file_type: "docx",
    updated_at: daysAgo(8),
  },
  {
    id: 103,
    user_id: 4,
    name: "Maria Garcia",
    branch: "Brisbane",
    department: "Marketing",
    job_title: "Marketing Coordinator",
    status: "missing",
    original_file_name: null,
    file_type: null,
    updated_at: null,
  },
  {
    id: 104,
    user_id: 5,
    name: "David Chen",
    branch: "Sydney",
    department: "IT",
    job_title: "Systems Analyst",
    status: "uploaded",
    original_file_name: "David_Chen_JD.pdf",
    file_type: "pdf",
    updated_at: daysAgo(1),
  },
  {
    id: 105,
    user_id: 6,
    name: "Emily Roberts",
    branch: "Perth",
    department: "Finance",
    job_title: "Accounts Executive",
    status: "missing",
    original_file_name: null,
    file_type: null,
    updated_at: null,
  },
  {
    id: 106,
    user_id: 7,
    name: "Ali Khan",
    branch: "Adelaide",
    department: "Admissions",
    job_title: "Case Officer",
    status: "uploaded",
    original_file_name: "Ali_Khan_JD.pdf",
    file_type: "pdf",
    updated_at: daysAgo(15),
  },
];

export const DEPARTMENT_OPTIONS = [
  "All departments",
  "Admissions",
  "Operations",
  "Marketing",
  "IT",
  "Finance",
  "General",
];

export const DEPARTMENT_FILTER_OPTIONS = DEPARTMENT_OPTIONS.filter(
  (d) => d !== "All departments",
);
